import { defaultColumns, defaultSort } from '../../components/processes/stockMovements/columns';

export default {
  state: {
    stockMovements: [],
    paginatedStockMovements: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    pageCount: 1,
    filterString: null,
    sorting: {
      prop: 'id',
      order: 'descending',
    },
  },
  getters: {
    stockMovements: state => state.stockMovements,
    paginatedStockMovements: state => state.paginatedStockMovements,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
    pageCount: state => state.pageCount,
  },
  mutations: {
    setStockMovements(state, stockMovements) {
      state.stockMovements = stockMovements;
    },
    setPaginatedStockMovements(state, paginatedStockMovements) {
      state.paginatedStockMovements = paginatedStockMovements
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setPageCount(state, pageCount) {
      state.pageCount = pageCount;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/stock-movement-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'stock-movement-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'stock-movement-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
        console.error(e)
      }
    },

    async fetch({ commit }, id) {
      return await axios.get(`api/stock-movements/${id}`);
    },

    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const stockMovements = await axios.get('api/stock-movements' + (query || ''));
        commit('setStockMovements', stockMovements);
      } catch (e) {
        console.error(e);
      }
      commit('setLoading', false);
    },

    async fetchAllWithPagination({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      commit('setPaginatedStockMovements', []);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }

        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const stockMovements = await axios.get('api/stock-movements/paginated' + (query || ''));
        commit('setCurrentPage', stockMovements.current_page);
        commit('setPaginatedStockMovements', stockMovements);
        commit('setPageCount', stockMovements.last_page);
      } catch (e) {
        console.error(e)
      }
      commit('setLoading', false);
    },

    async create({ commit }, payLoad) {
      await axios.post('api/stock-movements', payLoad);
    },

    async update({ commit }, payLoad) {
      await axios.put('api/stock-movements', payLoad);
    },

    async finalize({ commit }, id) {
      await axios.post('api/stock-movements/finalize/'+id);
    },

    async delete({ commit }, id) {
      await axios.delete('api/stock-movements/'+id);
    },
  },
};
